import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

export const importService = {
    importARCLogistics,
};
const baseUrl = `/api/imports`;

function importARCLogistics(formData: any): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/arclogistics-data`,
        customErrorMessage: `Failed to import ARC Logistics`,
        postBody: formData
    };
    return handleServiceRequest.post(getObject);
}